<!--
//================================================================================
// ID:BC020
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC020
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2023/10/31 | 富士通Japan株式会社    | 新規作成
//================================================================================
-->

<template>
	<main class="contents__main">
		<div>
			<div class="contents__information">
				<div class="padding__bottom-20 padding__top-5">
					<font-awesome-icon icon="exclamation-triangle" />
					<label class="label-tyuijikou width-attention">注意事項</label>
				</div>
				<div class="contents__caution--div div_row font-size">
					<div class="contents__caution--div_mark div-komejirusi-marginTop">
						<p class="contents__caution__p contents__caution--multiple"> 〇 </p>
					</div>
					<div class="line-height">
						<p class="contents__caution__p contents__caution--multiple">
							利用者登録を削除できます。 </p>
					</div>
				</div>
				<div class="contents__caution--div div_row font-size">
					<div class="contents__caution--div_mark div-komejirusi-marginTop">
						<p class="contents__caution__p contents__caution--multiple"> 〇 </p>
					</div>
					<div class="line-height">
						<p class="contents__caution__p contents__caution--multiple">
							以下の方は利用者登録を削除できません。 </p>
					</div>
				</div>
				<div class="contents__attention contents__caution__font">
					<ul>
						<li>抽せん方式募集に申し込んでいる方で、抽選結果通知メールを受信していない方</li>
						<li>ポイント募集に申し込んでいる方で、登録、低順位、非該当のメールのいずれも受信していない方</li>
						<li>随時募集に申し込んでいる方で、入居まで至っていない方または、申込み取消しのメールを受信していない方</li>
					</ul>
					<br>
				</div>
				<div class="contents__caution--div div_row font-size">
					<div class="contents__caution--div_mark div-komejirusi-marginTop">
						<p class="contents__caution__p contents__caution--multiple"> 〇 </p>
					</div>
					<div class="line-height">
						<p class="contents__caution__p contents__caution--multiple">
							利用者登録を削除しても、申込みはキャンセルされません。申込期間中の場合は、利用者登録削除前に、申込み確認画面から申込みをキャンセルしてください。申込期間が終了している場合は、都営住宅募集センターまでご連絡ください。
						</p>
					</div>
				</div>
				<div class="contents__caution--div div_row font-size">
					<div class="contents__caution--div_mark div-komejirusi-marginTop">
						<p class="contents__caution__p contents__caution--multiple"> 〇 </p>
					</div>
					<div class="line-height">
						<p class="contents__caution__p contents__caution--multiple">
							利用者登録を削除すると、一時保存している申込データが削除されるほか、過去の申込履歴を閲覧できなくなります。また、今後、都営住宅入居者募集サイトから申込みを行うには、再度利用者登録を行う必要があります。
						</p>
					</div>
				</div>
			</div>
			<h2 class="contents__h2 h2-margintop">利用者情報</h2>
			<section>
				<table class="contents__table--stripe detail">
					<tbody>
						<tr class="contents__input--tr background__color--white">
							<th class="contents__input--title th-border th-paddingtop border__bottom-none">
								利用者
							</th>
							<td class="td-border border__bottom-none">
								<div id="contents--name__area">
									<div>
										<label>
											氏：{{ form.nmName1Lbl }}
										</label>
										<br class="disp_br">
										<label class="margin-nameSpace">
											名：{{ form.nmName2Lbl }}
										</label>
									</div>
								</div>
							</td>
						</tr>
						<tr class="background__color--white">
							<th class="contents__input--title">
								フリガナ
							</th>
							<td>
								<div id="contents--name__area">
									<div>
										<label>
											氏：{{ form.nmKana1Lbl }}
										</label>
										<br class="disp_br">
										<label class="margin-nameSpace">
											名：{{ form.nmKana2Lbl }}
										</label>
									</div>
								</div>
							</td>
						</tr>
						<tr class="contents__input--tr background__color--light-gray">
							<th class="contents__input--title th-border th-paddingtop border__bottom-none">
								日本での通称名
							</th>
							<td class="border__bottom-none">
								<div id="contents--name__area" v-show="disp.tusyonameLbl">
									<div>
										<label>
											氏：{{ form.nmTusyoname1Lbl }}
										</label>
										<br class="disp_br">
										<label class="margin-nameSpace">
											名：{{ form.nmTusyoname2Lbl }}
										</label>
									</div>
								</div>
							</td>
						</tr>
						<tr class="background__color--light-gray">
							<th class="contents__input--title">フリガナ</th>
							<td>
								<div id="contents--name__area" v-show="disp.tusyokanaLbl">
									<div>
										<label>
											氏：{{ form.nmTusyokana1Lbl }}
										</label>
										<br class="disp_br">
										<label class="margin-nameSpace">
											名：{{ form.nmTusyokana2Lbl }}
										</label>
									</div>
								</div>
							</td>
						</tr>
						<tr class="contents__input--tr background__color--white">
							<th class="contents__input--title th-border th-paddingtop">
								生年月日
							</th>
							<td class="td-border">
								<label>{{ form.yearValue }}年{{ form.monthValue }}月{{ form.dayValue }}日</label>
							</td>
						</tr>
						<tr class="background__color--light-gray">
							<th class="contents__input--title th-paddingtop">
								郵便番号/現住所
							</th>
							<td>
								<div>
									{{ form.idZip1Lbl }} - {{ form.idZip2Lbl }}
								</div>
								<div class="margin-jyusyo">
									{{ form.txNowadr1Lbl }}
								</div>
								<div class="margin-jyusyo">
									{{ form.txNowadr2Lbl }}
								</div>
								<div class="margin-jyusyo">
									{{ form.txNowadr3Lbl }}
								</div>
							</td>
						</tr>
						<tr class="background__color--white">
							<th class="contents__input--title th-border th-paddingtop">
								電話番号
							</th>
							<td class="td-border">
								<label>{{ form.idTel1Lbl }} - {{ form.idTel2Lbl }} - {{ form.idTel3Lbl }}</label>
							</td>
						</tr>
						<tr class="background__color--light-gray">
							<th class="contents__input--title">
								メールアドレス
							</th>
							<td class="contents__kaigyo--css">
								<label>{{ form.mailLbl }}</label>
							</td>
						</tr>
					</tbody>
				</table>
				<br />
				<div class="contents__div--center margin__bottom-page">
					<input type="submit" value="削除する" class="contents__btn--confirm btn-confirmmargin" @click="sakujo"
						tabindex="1" />
					<input type="submit" value="戻る" class="contents__btn--cancel btn-cancelmargin" @click="modoru"
						tabindex="2" />
				</div>
				<br />
			</section>
		</div>
	</main>
</template>

<script>
import { co_post, co_put, co_moveSystemError } from '@/common/ajaxUtility.js';
import { co_confirmDialog, co_completedDialog, co_errorDialog } from '@/common/dialogUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_toTrans } from '@/common/screenUtility.js';
import { co_doLogout } from '@/common/logoutEventUtility.js';

import { STORE_ERROR_CLEAR, STORE_VIEW_PROGRESS } from '@/const/store.js';
import { DIALOG_BUTTON_LIST_KEY } from '@/const/const.js';
import { PATH_BC020_INIT, PATH_BC020_EXISTCHECK, PATH_BC020_CHANGINGCHECK, PATH_BC020_MOSIKOMICHECK, PATH_BC020_DELETEINFO } from '@/const/route.js';
import { E3005 } from '@/const/messageId.js';
export default {
	components: {

	},
	data: function () {
		return {
			form: {
				nmName1Lbl: "",				// 利用者氏名（氏）
				nmName2Lbl: "",				// 利用者氏名（名）
				nmKana1Lbl: "",				// フリガナ（氏）
				nmKana2Lbl: "",				// フリガナ（名）
				nmTusyoname1Lbl: "",		// 通称名（氏）
				nmTusyoname2Lbl: "",		// 通称名（名）
				nmTusyokana1Lbl: "",		// 通称フリガナ（氏）
				nmTusyokana2Lbl: "",		// 通称フリガナ（名）
				yearValue: "",				// 生年月日（年）
				monthValue: "",				// 生年月日（月）
				dayValue: "",				// 生年月日（日）
				idZip1Lbl: "",				// 郵便番号（上3桁）
				idZip2Lbl: "",				// 郵便番号（下4桁）
				txNowadr1Lbl: "",			// 現住所１
				txNowadr2Lbl: "",			// 現住所２
				txNowadr3Lbl: "",			// 現住所３
				idTel1Lbl: "", 				// 電話番号（市外）
				idTel2Lbl: "",				// 電話番号（市内）
				idTel3Lbl: "",				// 電話番号（局番）
				mailLbl: "",				// メールアドレス
			},
			disp: {
				tusyonameLbl: false,		// 日本での通称名（表示用）制御
				tusyokanaLbl: false,		// 日本での通称名フリガナ（表示用）制御
			},
		};
	},
	created: async function () {

		// エラークリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// 初期値設定
		let initInfo = await co_post(PATH_BC020_INIT, this.form);
		if (initInfo == '') {

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

			// システムエラー画面へ遷移
			co_moveSystemError([E3005]);
			return;
		}

		// 日本での通称名、フリガナ（表示用）制御
		if (initInfo.nmTusyoname1 == "" && initInfo.nmTusyoname2 == ""
			&& initInfo.nmTusyokana1 == "" && initInfo.nmTusyokana2 == "") {
			this.disp.tusyonameLbl = false;
			this.disp.tusyokanaLbl = false;
		} else {
			this.disp.tusyonameLbl = true;
			this.disp.tusyokanaLbl = true;
		}

		// メールアドレス
		this.form.mailLbl = initInfo.idMailaddress;
		// 利用者（氏）
		this.form.nmName1Lbl = initInfo.nmName1;
		// 利用者（名）
		this.form.nmName2Lbl = initInfo.nmName2;
		// 利用者フリガナ（氏）
		this.form.nmKana1Lbl = initInfo.nmKana1;
		// 利用者フリガナ（名）
		this.form.nmKana2Lbl = initInfo.nmKana2;
		// 日本での通称名（氏）
		this.form.nmTusyoname1Lbl = initInfo.nmTusyoname1;
		// 日本での通称名（名）
		this.form.nmTusyoname2Lbl = initInfo.nmTusyoname2;
		// 日本での通称フリガナ（氏）
		this.form.nmTusyokana1Lbl = initInfo.nmTusyokana1;
		// 日本での通称フリガナ（名）
		this.form.nmTusyokana2Lbl = initInfo.nmTusyokana2;
		// 生年月日（年）
		this.form.yearValue = initInfo.yrBirthday;
		// 生年月日（月）
		this.form.monthValue = ('00' + initInfo.mtBirthday).slice(-2);
		// 生年月日（日）
		this.form.dayValue = ('00' + initInfo.dyBirthday).slice(-2);
		// 郵便番号分割
		let yubinbango = initInfo.idZip.split('-');
		// 郵便番号（上3桁）
		this.form.idZip1Lbl = yubinbango[0];
		// 郵便番号（下4桁）
		this.form.idZip2Lbl = yubinbango[1];
		// 現住所１
		this.form.txNowadr1Lbl = initInfo.txNowadr1;
		// 現住所２
		this.form.txNowadr2Lbl = initInfo.txNowadr2;
		// 現住所３
		this.form.txNowadr3Lbl = initInfo.txNowadr3;
		// 電話番号分割
		let denwabango = initInfo.idTel.split('-');
		// 電話番号１
		this.form.idTel1Lbl = denwabango[0];
		// 電話番号２
		this.form.idTel2Lbl = denwabango[1];
		// 電話番号３
		this.form.idTel3Lbl = denwabango[2];

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);

	},
	methods: {

		// 「削除する」ボタン押下処理
		sakujo: async function () {
			// 削除済チェック
			let isExist = await co_post(PATH_BC020_EXISTCHECK);
			if (!isExist) {
				co_errorDialog(co_getMessage('E0133'), this.existErr);
				return;
			}
			// 利用者変更チェック
			let isChanging = await co_post(PATH_BC020_CHANGINGCHECK);
			if (isChanging) {
				co_errorDialog(co_getMessage('E0134'), this.changingErr);
				return;
			}
			// 申込情報チェック
			let isAppInfo = await co_post(PATH_BC020_MOSIKOMICHECK);
			if (isAppInfo) {
				co_errorDialog(co_getMessage('E0135'), this.mosikomiErr);
				return;
			}
			// 確認ダイアログ表示
			co_confirmDialog(co_getMessage("I0035"), this.doSakujo);
			return;
		},

		// 削除済エラーダイアログ「OK」ボタン押下時処理
		existErr: function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				return;
			}
		},

		// 利用者変更エラーダイアログ「OK」ボタン押下時処理
		changingErr: function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				return;
			}
		},

		// 申込中エラーダイアログ「OK」ボタン押下時処理
		mosikomiErr: function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				return;
			}
		},

		// 確認ダイアログ「はい」ボタン押下時処理
		doSakujo: async function (flg) {
			// ダイアログ「はい」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {

				// ローディング表示開始
				this.$store.commit(STORE_VIEW_PROGRESS, true);

				// 利用者削除処理呼び出し
				await co_put(PATH_BC020_DELETEINFO);

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				// 完了ダイアログ表示
				co_completedDialog(co_getMessage("I0037"), this.doCompletedDelete);
			}
			// ダイアログ「いいえ」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.CANCEL) {
				// ダイアログを閉じる
				return;
			}
		},

		doCompletedDelete: async function (flg) {

			// ログアウト実行
			co_doLogout();

			// 削除完了ダイアログ「はい」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {

				// 都営住宅入居者募集サイトポータルページに遷移
				window.location.href = 'https://www.juutakuseisaku.metro.tokyo.lg.jp/toei_online/index.html'; 
				return;
			}
		},

		// 戻るボタン押下時処理
		modoru: async function () {
			// メニュー画面に遷移
			co_toTrans('BC002');
		},

	},
};
</script>

<style scoped>
.h2-margintop {
	margin-top: 20px;
}

.contents__information {
	color: #fe0000 !important;
	font-size: 16px !important;
}

.contents__caution__p {
	font-size: 91.6%;
	display: inline;
}

.contents__caution__font {
	font-size: 91.6%;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {
	.btn-confirmmargin {
		margin-bottom: 2%;
		margin-right: 50px;
	}

	.btn-cancelmargin {
		margin-bottom: 2%;
		margin-left: 50px;
	}

	.label-tyuijikou {
		font-size: 20px;
		margin-left: 1%;
	}

	.contents__attention {
		margin-left: 40px !important;
		line-height: 1.4em !important;
	}

	.margin-nameSpace {
		margin-left: 11px;
	}

	.disp_br {
		display: none;
	}

}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {
	.btn-confirmmargin {
		margin-right: 35px;
	}

	.label-tyuijikou {
		font-size: 18px;
		margin-left: 1%;
	}

	.contents__attention {
		list-style: none;
		margin-left: 40px;
		display: inline-flex;
		line-height: 1.4em !important;
	}

	.disp_br {
		display: block;
	}

	.contents__table--stripe th{
		padding: 0px 0px 0px 10px;
	}
	.contents__table--stripe td {
		padding: 0px 0px 10px 10px;
	}
}
</style>